<template>
  <el-form :model="form" :rules="rules" ref="form" class="data-card">
    <div class="data-card__header">
      <div class="d-flex align-items-baseline flex-wrap">
        <h3 class="my-0 mr-3">{{status.statusTitle}}</h3>
<!--        <span>от {{dateFormatToMoscowTime(claimData.createdAt)}}(МСК)</span>-->
      </div>
      <div class="d-flex">
        <div v-if="$isAccess($userRoles.Admin, $userRoles.Specialist, $userRoles.Dispatcher) && $user.workWithOrdersAccess" class="ml-3">
          <el-button v-if="isEdited" type="primary" size="medium" :loading="updateProgress || uploadFileCount>0" @click="onSave">
            Сохранить
          </el-button>
          <el-button v-else size="medium" @click="isEdited=true" :loading="updateProgress">
            Изменить
          </el-button>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <el-form-item prop="reasonId">
        <el-select v-model="form.reasonId" filterable class="w-100" size="medium"
                   :disabled="!isEdited || !$isAccess($userRoles.Admin, $userRoles.Dispatcher)"
                   :loading="fetchOrderStatusReasonsProgress" placeholder="" ref="reasonIdRef">
          <el-option v-for="option in filteredReasons" :key="option.reasonId" :label="option.displayName" :value="option.reasonId" />
        </el-select>
        <span class="floating-span"
              :class="{'floating-span_active': $notEmpty(form.reasonId) || $notEmpty($refs.reasonIdRef && $refs.reasonIdRef.query)}">
          Выберите причину
        </span>
      </el-form-item>

      <el-form-item prop="comment" class="mt-3">
        <el-input type="textarea"
                  :rows="4"
                  maxlength="200"
                  show-word-limit
                  v-model="form.comment"
                  :disabled="!isEdited"
                  resize="none"/>
        <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.comment) }">Комментарий</span>
      </el-form-item>
    </div>

    <FilesBlock :files="form.files" :isEdited="isEdited && $isAccess($userRoles.Admin, $userRoles.Dispatcher)" @onRemove="onRemoveFile" />

    <div class="d-flex flex-wrap flex-gap-10 mt-3">
      <el-form-item v-if="isEdited && $isAccess($userRoles.Admin, $userRoles.Dispatcher)" prop="files">
        <el-upload ref="upload" action="/" multiple
                   :show-file-list="false" :auto-upload="false"
                   :on-change="onChangeFiles">
          <el-button slot="trigger" icon="el-icon-plus" size="medium">
            Прикрепить файл
          </el-button>
        </el-upload>
      </el-form-item>

      <div v-if="showSaveAllFiles">
        <el-button size="medium" @click="onSaveAllFiles">Скачать все файлы</el-button>
      </div>
    </div>

  </el-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { MESSAGES } from '@/commons/constants/errorMessages';
import FilesBlock from '@/components/ui/FilesBlock';
import apiClient from '@/services/api/apiClient';
import { dateFormatToMoscowTime } from '@/commons/helpers';

export default {
  components: {
    FilesBlock,
  },
  data: () => ({
    isEdited: false,
    uploadFileCount: 0,
    form: {
      reasonId: null,
      comment: '',
      files: [],
    },
    rules: {
      reasonId: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
      ],
    },
  }),
  computed: {
    ...mapGetters({
      item: 'orders/item',
      updateProgress: 'orders/updateProgress',
      orderStatusReasons: 'orderStatusReasonsDrop/items',
      fetchOrderStatusReasonsProgress: 'orderStatusReasonsDrop/fetchProgress',
    }),
    status() {
      return this.item.visitOrderStatus;
    },
    showSaveAllFiles() {
      return this.status.files.length;
    },
    filteredReasons() {
      return this.orderStatusReasons.filter((x) => !x.isDeleted || this.status.statusChangeReasonId === x.reasonId);
    },
  },
  methods: {
    ...mapActions({
      updateStatus: 'orders/updateStatus',
      fetchOrderStatusReasons: 'orderStatusReasonsDrop/fetchItems',
      uploadFileGetUrl: 'files/uploadFileGetUrl',
      getZipKey: 'files/getZipKey',
    }),
    dateFormatToMoscowTime,
    fillForm() {
      this.form.reasonId = this.status.statusChangeReasonId;
      this.form.comment = this.status.statusChangeComment;

      this.form.files = this.status.files.map((file) => ({
        fileName: file.fileName,
        id: file.fileId,
        url: file.fileUrl,
        contentType: file.fileContentType,
      }));
    },
    onChangeFiles(evt) {
      this.uploadFileCount += 1;
      this.uploadFileGetUrl({ file: evt.raw })
        .then((file) => {
          this.form.files.push(file);
        })
        .finally(() => {
          this.uploadFileCount -= 1;
        });
    },
    onRemoveFile(file) {
      const fileIndex = this.form.files.findIndex((f) => f.id === file.id);
      if (fileIndex > -1) {
        this.form.files.splice(fileIndex, 1);
      }
    },
    onSaveAllFiles() {
      const { files } = this.status;

      const filesOldStructure = files.map((file) => ({
        fileName: file.fileName,
        id: file.fileId,
        url: file.fileUrl,
        contentType: file.fileContentType,
      }));
      this.getZipKey({ files: filesOldStructure })
        .then((data) => {
          const link = document.createElement('a');
          link.href = `${apiClient.defaults.baseURL}/files/zip/${data.downloadKey}`;
          link.click();
        });
    },
    onSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { visitOrderId: id } = this.item;
          const data = {
            ...this.form,
            status: this.status.statusId,
          };

          this.updateStatus({ id, data })
            .then(() => {
              this.isEdited = false;
            });
        }
      });
    },
  },
  created() {
    this.fetchOrderStatusReasons();
    this.fillForm();
  },
  watch: {
    item() {
      this.isEdited = false;
      this.fillForm();
    },
  },
};
</script>
